import { useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default function OlvidePassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMsg('');
    try {
      const r = await axios.post(`${API}/auth/olvide-password`, { email });
      setMsg(r.data.msg);
    } catch (err) {
      setError(err.response?.data?.detail || 'Error, intenta de nuevo');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logo}>🔒</div>
        <h1 style={styles.title}>Recuperar contraseña</h1>
        <p style={styles.sub}>Te enviaremos un enlace a tu correo para restablecerla.</p>

        {msg ? (
          <div style={styles.msgOk}>{msg}</div>
        ) : (
          <form onSubmit={submit} style={styles.form}>
            <input
              style={styles.input} type="email" placeholder="Correo electrónico *"
              value={email} onChange={e => setEmail(e.target.value)} required
            />
            {error && <p style={styles.error}>{error}</p>}
            <button style={styles.btn} disabled={loading}>
              {loading ? 'Enviando...' : 'Enviar enlace'}
            </button>
          </form>
        )}

        <a href="/login" style={styles.back}>&larr; Volver a ingresar</a>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f4f4f5' },
  card: { background: '#fff', borderRadius: 16, padding: '2.5rem 2rem', width: 420, boxShadow: '0 4px 24px rgba(0,0,0,0.08)' },
  logo: { fontSize: 40, textAlign: 'center', marginBottom: 8 },
  title: { textAlign: 'center', fontSize: 22, fontWeight: 600, margin: 0 },
  sub: { textAlign: 'center', color: '#666', fontSize: 14, marginBottom: 24, marginTop: 4 },
  form: { display: 'flex', flexDirection: 'column', gap: 10 },
  input: { padding: '10px 14px', borderRadius: 8, border: '1px solid #e0e0e0', fontSize: 14, outline: 'none', width: '100%', boxSizing: 'border-box' },
  btn: { padding: '12px', borderRadius: 8, background: '#2563eb', color: '#fff', border: 'none', fontWeight: 600, fontSize: 15, cursor: 'pointer', marginTop: 4 },
  error: { color: '#dc2626', fontSize: 13, margin: 0 },
  msgOk: { color: '#16a34a', fontSize: 14, background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 8, padding: '12px 14px', textAlign: 'center' },
  back: { display: 'block', textAlign: 'center', marginTop: 20, fontSize: 13, color: '#2563eb', textDecoration: 'none' },
};
